/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Step 6 (Review & Confirm) tag for a composite. The reason under a dropped tag, and which side changed under replaced, are carried by rowStatusDetail. needSelection is the new edition holding data the row has no pick for yet — the Step 5 status of the same name, carried through so the row is not reported as new or dropped while it is still waiting on the user. The last two are the Use Previous outcome: newJobMapCreated where the row also carries a new mapping to show, retained where it does not. Both come with a retained side; see SurveyReplacementReviewDiffRow.retained.
 */
export enum SurveyReplacementReviewDiffRowStatus {
    REPLACED = 'replaced',
    NO_CHANGES = 'noChanges',
    DROPPED = 'dropped',
    NEED_SELECTION = 'needSelection',
    NEW_MAPPING = 'newMapping',
    NEW_JOB_MAP_CREATED = 'newJobMapCreated',
    RETAINED = 'retained',
}
